export const DEFAULT_OBJECT_COLOR = '#415363';
